/**
* AI写作-发布配置
**/ 

<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item >发布配置</el-breadcrumb-item>
        <!-- <el-breadcrumb-item v-if="detailShow">详情</el-breadcrumb-item> -->
        </el-breadcrumb>

        <el-card class="box-card">
            <!-- 标题列表 s -->
            <div class="box-table" >

                <!-- 搜索筛选 -->
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-input placeholder="查询关键字" v-model="formInline.keyword" class="input-with-select" :size="size">
                            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
                        </el-input>
                    </el-col>
                    <el-col :span="2.5">
                        <el-button type="primary" plain icon="el-icon-search" @click="addHandler" :size="size">添加配置</el-button>
                    </el-col>
                </el-row>

                <!--列表-->
                <el-table :size="size" tooltip-effect="dark" :data="listData" highlight-current-row v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;margin-top:20px">
                    <el-table-column sortable  prop="id" label="编号" >
                    </el-table-column>
                    <el-table-column sortable prop="name" label="配置名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column sortable prop="platform" label="平台" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column sortable prop="domain" label="域名">
                    </el-table-column>
                    <el-table-column sortable prop="state" label="状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                        <span>{{scope.row.state | state}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="publishTime" label="发布时间" >
                    </el-table-column>
                    <el-table-column sortable prop="count" label="日发布量" >
                    </el-table-column>
                    <el-table-column align="center" label="操作">
                        <template  slot-scope="scope">
                            <el-button type="text" size="mini" @click="editHandler(scope.row)"><i class="el-icon-edit"></i></el-button>
                            <el-button type="text" size="mini" @click="delHandler(scope.row.id)"><i class="el-icon-delete" style="color:red"></i></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页组件 -->
                <Pagination style="float:right" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

            </div>
            <!-- 标题列表 e -->
        </el-card>
  
        <!-- 发布配置 -->
        <el-dialog
            title="发布配置"
            :visible.sync="addDialogVisible"
            width="40%"
            :close-on-click-modal="false">
            <div style="padding: 0px 20px 0px 20px;">
                <el-form  :model="form1" :rules="rules1" ref="ruleForm1" :size="size" label-width="140px">
                    <el-form-item label="选择平台" prop="platform">
                        <el-select style="width:100%" v-model="form1.platform" >
                            <el-option label="迅睿" :value="'迅睿'"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-form label-width="140px" :model="form2" :rules="rules2" ref="ruleForm2" :size="size" v-if="form1.platform=='迅睿'">
                    <el-form-item label="迅睿appid" prop="appid">
                        <el-input v-model="form2.appid"  > </el-input>
                    </el-form-item>
                    <el-form-item label="迅睿appsecret" prop="appsecret">
                        <el-input v-model="form2.appsecret"  > </el-input>
                    </el-form-item>
                    <el-form-item label="迅睿栏目ID" prop="catid">
                        <el-input v-model="form2.catid"  > </el-input>
                    </el-form-item>
                    <!-- <el-form-item label="迅睿缩略图ID" prop="thumb">
                        <el-input v-model="form2.thumb"  > </el-input>
                    </el-form-item> -->
                    <el-form-item label="迅睿模块（目录）" prop="module">
                        <el-input v-model="form2.module"  > </el-input>
                    </el-form-item>
                    <el-form-item label="迅睿用户名" prop="username">
                        <el-input v-model="form2.username"  > </el-input>
                    </el-form-item>
                    <el-form-item label="迅睿密码" prop="password">
                        <el-input v-model="form2.password"  > </el-input>
                    </el-form-item>
                </el-form>
                <el-form label-width="140px" :model="form3" :rules="rules3" ref="ruleForm3" :size="size">
                    <el-form-item label="登录网址" prop="domain">
                        <el-input v-model="form3.domain"  > </el-input>
                    </el-form-item>
                    <el-form-item label="配置名称" prop="name">
                        <el-input v-model="form3.name"  > </el-input>
                    </el-form-item>
                    <el-form-item label="自动发布时间配置" prop="state">
                        <el-select style="width:100%" v-model="form3.state" >
                            <el-option label="自动发布" :value="1"> </el-option>
                            <!-- <el-option label="手动发布" :value="0"> </el-option> -->
                        </el-select>
                    </el-form-item>
                    <el-form-item label="每天自动发布数量" prop="count" v-if="form3.state==1">
                        <el-input v-model="form3.count"  > </el-input>
                    </el-form-item>
                    <el-form-item label="每天自动发布时间" prop="publishTime" v-if="form3.state==1">
                        <el-time-select style="width:100%"
                            v-model="form3.publishTime"
                            :picker-options="{
                                start: '00:30',
                                step: '00:30',
                                end: '23:30'
                            }"
                            placeholder="选择时间">
                        </el-time-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addSubmit">确 定</el-button>
            </span>
        </el-dialog>
    
    </div>
</template>

<script>
// 导入组件
import Pagination from '@/components/Pagination'
import {AiPlatform1,AiPlatform2} from "@/module/entity";
import Qs from 'qs';
import { createConfig, modifyConfig, delConfig ,getConfig} from '@/api/basisMG' 
// 导出模块
export default {
  // 模块名字
  name: "template",
  // 模块数据
  data() {
    //数据  
    return {
      addDialogVisible: false, //添加对话框显示
      size: 'small',
      loading: false,
      formInline: {
        page: 1,
        pageSize: 10,
        keyword: ''
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      listData:[],
      form1: {platform: null,id: null},
      rules1: {
        platform: [
            { required: true, message: '请选择对接平台', trigger: 'blur' }
          ],
      },
      form2: new AiPlatform1(),
      rules2: {
        appid: [ { required: true, message: '请输入appid', trigger: 'blur' } ],
        appsecret: [ { required: true, message: '请输入appsecret', trigger: 'blur' } ],
        catid: [ { required: true, message: '请输入栏目ID', trigger: 'blur' } ],
        // thumb: [ { required: true, message: '请输入缩略图ID', trigger: 'blur' } ],
        module: [ { required: true, message: '请输入模块路径', trigger: 'blur' } ],
        username: [ { required: true, message: '请输入用户名', trigger: 'blur' } ],
        password: [ { required: true, message: '请输入密码', trigger: 'blur' } ],
      },
      form3: new AiPlatform2(),
      rules3: {
        domain: [ { required: true, message: '请输入登录网址', trigger: 'blur' } ],
        name: [ { required: true, message: '请输入配置名称', trigger: 'blur' } ],
        count: [ { required: true, message: '请输入每日发布量', trigger: 'blur' } ],
        state: [ { required: true, message: '请选择发布类型', trigger: 'blur' } ],
        publishTime: [ { required: true, message: '请选择发布时间', trigger: 'blur' } ],
      },
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    addSubmit() {
        let array = []
        this.$refs['ruleForm1'].validate((valid) => {
            if(!valid){
                array.push(false)
            }
        })
        this.$refs['ruleForm2'].validate((valid) => {
            if(!valid){
                array.push(false)
            }
        })
        this.$refs['ruleForm3'].validate((valid) => {
            if(!valid){
                array.push(false)
            }
        })
        if(array.length==0){
            const params = {
                platform: this.form1.platform,
                domain: this.form3.domain,
                name: this.form3.name,
                count: this.form3.count,
                publishTime: this.form3.publishTime,
                params: JSON.stringify(this.form2),
                state: this.form3.state
            }
            if(!this.form1.id){
                createConfig(params).then(res=>{
                    if(res.code===0){
                        this.$message.success('添加成功')
                        this.addDialogVisible=false
                        this.search()
                    }
                })
            }else{
                modifyConfig(this.form1.id,params).then(res=>{
                    if(res.code===0){
                        this.$message.success('编辑成功')
                        this.addDialogVisible=false
                        this.search()
                    }
                })
            }
        }
        
    },
    
     // 获取订单列表
     getdata(parameter) {
        const params={
            keyword: parameter.keyword,
            state: parameter.state,
            domain: parameter.domain,
            page: parameter.page,
            pageSize: parameter.pageSize
        }
        this.loading = true
        getConfig(params).then(res => {
            this.loading = false
            if (res.code == 0) {
                // this.$message({ type: 'info', message: res.message })
                this.listData = res.data
                // 分页赋值
                this.pageparm.currentPage = this.formInline.page
                this.pageparm.pageSize = this.formInline.pageSize
                this.pageparm.total = res.totalCount
            } else {
                this.$message({ type: 'error', message: res.message })
            }
        })
    },
    search(){
        this.getdata(this.formInline)
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    addHandler(){
        this.form2 = new AiPlatform1()
        this.form3 = new AiPlatform2()
        this.addDialogVisible = true

    },
    editHandler(row){
        this.form1.platform = row.platform
        this.form1.id = row.id
        this.form2 = JSON.parse(row.params)
        this.form3 = row
        this.addDialogVisible = true

    },
    delHandler(id){
        this.$confirm('确认删除吗？', '提示', {}).then(() => {
            console.log(id)
            delConfig({"id":id}).then(res=>{
                if(res.code===0){
                    this.$message.success('删除成功')
                    this.search()
                }
            })
        })
    },
  },
  
  filters: {
    timestampToTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:SS')
    },
    state(num) {
      switch (num) {
        case 0:
          return '停用'
        case 1:
          return '启用'
        case 2:
          return '启用'
        default:
          return ''
      }
    },
  },
  // 创建前状态(里面是操作)
  beforeCreate() {},
  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载前状态(里面是操作)
  beforeMount() {},
  // 挂载结束状态(里面是操作)
  mounted() {
    this.search()
    const query = Qs.parse(location.search.substring(1))
    // console.log("token=>"+accessToken)
    // alert("token=>"+accessToken)
    if(query.operation=='add'){
      this.addDialogVisible = true
    }
  },
  // 更新前状态(里面是操作)
  beforeUpdate() {},
  // 更新完成状态(里面是操作)
  updated() {},
  // 销毁前状态(里面是操作)
  beforeDestroy() {},
  // 销毁完成状态(里面是操作)
  destroyed() {}
};
</script>
// scoped 样式只在本组件使用
<style scoped>
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
</style>



// WEBPACK FOOTER //
// src/views/ai/writer/config.vue